import { z } from 'zod';

// Toda respuesta de la API v1 viaja envuelta en `ApiResponse` (specs/contexts/api-v1-migration/
// mapping.md §S-1). Se desenvuelve en el interceptor de `http.ts` para que los ~530 call sites de
// `infrastructure/` sigan leyendo `const { data } = await apiClient.get(...)` sin cambios.
const ApiEnvelopeSchema = z.object({
  status: z.boolean(),
  message: z.string(),
  data: z.unknown(),
  timestamp: z.string(),
});

/**
 * Devuelve el payload real de una respuesta v1.
 *
 * Es deliberadamente tolerante: si el cuerpo no tiene forma de envelope lo devuelve tal cual, para
 * que un backend que responda algo inesperado falle en el zod del repositorio —con el nombre del DTO
 * en el mensaje— y no aquí con un error genérico sin contexto (plan.md §2).
 */
export function unwrapApiResponse(payload: unknown): unknown {
  const parsed = ApiEnvelopeSchema.safeParse(payload);
  return parsed.success ? parsed.data.data : payload;
}
